module.exports = __webpack_public_path__ + "assets/large-user-table.a419c2ba.svg";